import { createSlice } from "@reduxjs/toolkit";
import { getStripePublishKey } from "../actions/stripePayment.actions";

const initialState = {
  isLoading: true,
  data: null,
};

const getStripePublishKeySlice = createSlice({
  name: "Get Publish Key",
  initialState,
  reducers: {
    resetStripePublishKey(state) {
      (state.isLoading = initialState?.isLoading), (state.data = initialState?.data);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getStripePublishKey.pending, (state) => {
      state.isLoading = true;
      state.data = null;
    });

    builder.addCase(getStripePublishKey.fulfilled, (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    });

    builder.addCase(getStripePublishKey.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const { resetStripePublishKey } = getStripePublishKeySlice.actions;
export default getStripePublishKeySlice.reducer;
